module.exports = __webpack_public_path__ + "fonts/EuclidCircularA-Regular-WebS.9cf5f4f.woff2";